import React, {Component} from 'react';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import {Button} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import axios from 'axios';
import {CircularProgress} from "@material-ui/core";
import {Link} from "react-router-dom";

const apiBaseUrl = process.env.REACT_APP_API_URL;

class ForgotPassword extends Component {
    state = {
        email: ''
    };

    constructor(props) {
        super(props);
        globalProps = props;
    }

    render() {
        return (
            <div className="login-background">
                <MuiThemeProvider>
                    <img src={require('../../JXB Logo.png')} alt="JXB Performance" style={{width: 200, margin: '20px auto 0'}} />
                    <div className="container" style={{maxWidth: 400, marginTop: 20, padding: '25px 10px'}}>
                        <div>
                            <TextField
                                placeholder="Enter your email"
                                label="Email"
                                variant="outlined"
                                fullWidth
                                autoComplete="off"
                                onChange={(event) => this.setState({email: event.target.value})}
                                onKeyPress={(event) => {
                                    this.handleEnter(event);
                                }}
                            />
                            <div ref="btnForgotPassword" style={{display: 'block'}}>
                                <Button primary={true} style={style}
                                              className="success-button-lg"
                                              onClick={(event) => this.sendPasswordReset(event)}>Email Reset Link</Button>
                            </div>
                            <div ref="divLoading" style={{display: 'none'}}>
                                <br/>
                                <CircularProgress />
                            </div>
                            <br/>
                            <div style={{fontWeight: 600, fontSize: 16}}>
                                Just remembered it? :)
                            </div>
                            <div>
                                <Link to="/login">
                                    <Button label="Back to login" primary={true}
                                                  className="success-button-lg"
                                                  style={style}>Back to login</Button>
                                </Link>
                            </div>
                        </div>
                        <br />
                        <center>&#9400; {new Date().getFullYear()} JXB Performance, All rights reserved.</center>
                    </div>
                </MuiThemeProvider>
            </div>
        );
    }

    handleEnter(event) {
        if (event.key === 'Enter') {
            this.sendPasswordReset(event);
            event.preventDefault();
        }
    }

    sendPasswordReset = () => {
        const self = this;
        const payload = {
            "email": this.state.email,
            "password": "a"
        };
        self.refs.btnForgotPassword.style = "display: none;";
        self.refs.divLoading.style = "display: block;";
        if (this.state.email.length > 0) {
            axios.post(`${apiBaseUrl}users/password_reset`, payload).then(function (resetResponse) {
                if (resetResponse.status === 200) {
                    globalProps.history.push('/password/sent');
                }
            })
                .catch(function (error) {
                    window.$alertWarning('Uh oh! Something went wrong.');
                    console.log(error);
                    self.refs.btnForgotPassword.style = "display: block";
                    self.refs.divLoading.style = "display: none;";
                });
        } else {
            window.$alertWarning('Enter your email and try again.');
            self.refs.btnForgotPassword.style = "display: block";
            self.refs.divLoading.style = "display: none;";
        }
    };
}

let globalProps;

const style = {
    margin: 15,
};

export default ForgotPassword;
